import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface AvaliacaoDeliveryItem {
    id: number
    clienteNome: string
    facebookId: string | null
    telefoneCliente: string | null
    dataHora: number | null
    nota: number | null
    comentario: string | null
    idPedido: number
}

export interface ResultadoAvaliacoesDelivery {
    avaliacoes: AvaliacaoDeliveryItem[]
    total: number
    media: number | null
    nps: number | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterAvaliacoesDelivery = async function (
    authorization: string,
    inicio?: number,
    fim?: number
): Promise<ResultadoAvaliacoesDelivery | ErroApi> {
    try {
        const params = new URLSearchParams()
        if (inicio != null) params.append("inicio", String(inicio))
        if (fim != null) params.append("fim", String(fim))
        const query = params.toString() ? `?${params.toString()}` : ""

        const response = await api
            .get<RespostaRaw<ResultadoAvaliacoesDelivery>>(
                `avaliacao/ObterAvaliacoesDelivery${query}`,
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ResultadoAvaliacoesDelivery>(response, "ObterAvaliacoesDelivery")
    } catch (error) {
        RegistrarLogErro(error, "ObterAvaliacoesDelivery", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterTextoPedido = async function (
    authorization: string,
    idPedido: number
): Promise<string | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<{ retorno: string }>>(`integracao/impressao/${idPedido}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data.codErro !== undefined && response.data.codErro > 0) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        const raw = response.data as unknown as { retorno?: string }
        return raw.retorno ?? ""
    } catch (error) {
        RegistrarLogErro(error, "ObterTextoPedido", String(idPedido))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
